import { YHistoryEditor, YjsEditor } from '@slate-yjs/core';
import type { Editor } from 'slate';
import type { HistoryEditor } from 'slate-history';

export type HistoryEditorLike = HistoryEditor | YHistoryEditor;

export const HistoryTransforms = {
  clearHistory: (editor: HistoryEditorLike): void => {
    // Until we fix Jest, guard against YHistoryEditor being undefined...
    if (YHistoryEditor === undefined) return;
    if (YHistoryEditor.isYHistoryEditor(editor)) {
      editor.undoManager.clear(true, true);
      return;
    }

    editor.history.redos = [];
    editor.history.undos = [];
  },

  redo: (editor: HistoryEditorLike): void => {
    return editor.redo();
  },

  /**
   * Run `fn` as a separate undo step from whatever just happened on `editor`.
   *
   * Only splits history for Yjs: flush buffered local ops so they become their
   * own stack item, then `stopCapturing()` so `fn` isn't merged by captureTimeout.
   * Non-Yjs editors just run `fn` — Slate/client history merging is left alone.
   */
  separateUndoCapture(editor: Editor, fn: () => void): void {
    if (YHistoryEditor.isYHistoryEditor(editor)) {
      // slate-yjs buffers ops until onChange; flush so create is committed before we split.
      if (YjsEditor.connected(editor)) {
        YjsEditor.flushLocalChanges(editor);
      }
      editor.undoManager.stopCapturing();
    }

    fn();
  },

  undo: (editor: HistoryEditorLike): void => {
    return editor.undo();
  },
};
